import { animate, style, transition, trigger } from '@angular/animations';

export const basicFade = trigger('basicFade', [
  transition(':enter', [style({ opacity: 0 }), animate(600, style({ opacity: 1 }))]),
  transition(':leave', [style({ opacity: 1 }), animate('0.5s ease-in', style({ opacity: 0 }))]),
]);
